export const MAIN_NAVIGATION_ITEMS = [
  // temporary icon fix for the safari
  {
    title: "Home",
    icon: require("@/assets/svg/navigation-drawer/dashboard_blue.svg"),
    permission: "dashboard",
    routeName: "dashboard"
  },
  {
    title: "People",
    icon: require("@/assets/svg/navigation-drawer/workers_blue.svg"),
    permission: "workers",
    routeName: "candidates"
  },
  {
    title: "Roles",
    icon: require("@/assets/svg/navigation-drawer/bookings_blue.svg"),
    permission: "bookings",
    routeName: "jobs"
  },
  {
    title: "Job Board",
    icon: require("@/assets/svg/navigation-drawer/bookings_blue.svg"),
    permission: "job-boards.external",
    routeName: "roles",
    isExternalLink: true,
    description: "Find new roles to apply to"
  },
  {
    title: "Job Board",
    icon: require("@/assets/svg/navigation-drawer/bookings_blue.svg"),
    permission: "job-boards.internal",
    routeName: "internal-roles-zkqgHGoutg",
    isExternalLink: true,
    description: "Find new roles to apply to"
  },
  {
    title: "Redeployee Job Board",
    icon: require("@/assets/svg/navigation-drawer/bookings_blue.svg"),
    permission: "job-boards.redeployment",
    routeName: "redeployment-roles-zkqgHGoutg",
    isExternalLink: true,
    description: "Find new roles to apply to"
  },
  {
    title: "Applications",
    icon: require("@/assets/svg/navigation-drawer/applications_blue.svg"),
    permission: "applications",
    routeName: "applications",
    description: "View your existing applications",
    activeClass: "white-line"
  },
  {
    title: "Interviews",
    icon: require("@/assets/svg/navigation-drawer/interviews_blue.svg"),
    permission: "interviews",
    routeName: "interviews",
    description: "View your existing interviews",
    activeClass: "white-line"
  },
  {
    title: "Offers",
    icon: require("@/assets/svg/navigation-drawer/offers_blue.svg"),
    permission: "offers",
    routeName: "offers",
    activeClass: "fill-none"
  },
  {
    title: "Conversations",
    icon: require("@/assets/svg/navigation-drawer/messages_blue.svg"),
    permission: "conversations",
    routeName: "conversations",
    activeClass: "white-rect"
  },
  {
    title: "Agencies",
    icon: require("@/assets/svg/navigation-drawer/agencies_blue.svg"),
    permission: "agencies",
    routeName: "agencies"
  },
  {
    title: "Reports",
    icon: require("@/assets/svg/navigation-drawer/reports_blue.svg"),
    permission: "focused-reports.view",
    routeName: "reports",
    activeClass: "white-rect"
  },
  {
    title: "Exports",
    icon: require("@/assets/svg/navigation-drawer/reports_blue.svg"),
    permission: "reports",
    routeName: "exports",
    activeClass: "white-rect"
  }
];

export const SETTINGS_NAVIGATION_ITEM = {
  icon: require("@/assets/svg/navigation-drawer/settings_blue.svg"),
  permission: "settings",
  routeName: "settings/profile",
  activeClass: "fill-none"
};

export const USER_GUIDE_NAVIGATION_ITEM = {
  icon: require("@/assets/svg/navigation-drawer/help_blue.svg"),
  isExternalLink: true,
  href: "https://alvius.zendesk.com/hc/en-gb"
};
